import React, { useState } from 'react';
import moment from 'moment';
import { CircularProgress } from '@mui/material';
import { Form } from 'react-bootstrap';
import timeDiff from '../../../../Utils/calculation/timeDiff';
import { saveGuestBookingData } from '../../../../Utils/guestBookingStorage';

const GuestChooseDate = ({ 
  hostObj, 
  host, 
  data, 
  handleNext, 
  dateVisible, 
  loadingWash, 
  setDateVisible, 
  value, 
  setValue, 
  priceArry, 
  setPriceArry,
  price, 
  setPrice, 
  setObjName, 
  allData, 
  slots, 
  setSlots, 
  setAddOn, 
  setSelectClasses, 
  setSelectSlots, 
  setClassTime, 
  setPriceDisplay, 
  addOn, 
  selectClasses, 
  selectSlots, 
  priceDisplay 
}: any) => {

  const [error, setError] = useState<any>({});
  const [showBundles, setShowBundles] = useState<any>(false);
  const [selectedSlot, setSelectedSlot] = useState<any>(null);
  const [errorAdd, setErrorAdd] = useState<any>([]);
  const [selectSlot, setSelectSlot] = useState<any>([]);

  const disPlayTime = (date: any) => {
    if (!date) return 'Invalid time';
    try {
      const Cdate = new Date(date);
      if (isNaN(Cdate.getTime())) return 'Invalid time';
      let converted_date = Cdate.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      return moment(converted_date).format("LT");
    } catch (error) {
      console.error('Error formatting time:', error, date);
      return 'Invalid time';
    }
  };

  const openAddonClass = (res: any) => {
    let obj = {
      ["appointment_date_time"]: res?.time,
      ["appointment_type_id"]: res?.appointmentTypeID,
      ["calendar_id"]: res?.calendarID
    };
    setSelectedSlot(res);
    setShowBundles(true);
    setObjName(res);
    setSlots(obj);
    setPrice(hostObj?.price);
    setPriceDisplay({
      price: hostObj?.price,
      actualPrice: hostObj?.price
    });
  };

  const handleBundleSelection = () => {
    let bookSlots: any = [];
    if (Object.keys(selectSlots).length > 0) {
      for (const prop in selectSlots) {
        if (selectSlots[prop]?.isChecked) {
          bookSlots.push({
            appointment_date_time: selectSlots[prop].appointment_date_time, 
            appointment_type_id: selectSlots[prop].appointment_type_id, 
            calendar_id: selectSlots[prop].calendar_id,
            name: selectSlots[prop]?.name
          });
        }
      }
    }

    let appointmentData;
    if (bookSlots.length > 0) {
      appointmentData = {
        ...value,
        ["addon_class"]: bookSlots,
        ["service_name"]: hostObj?.name,
        ["amount"]: priceDisplay.actualPrice ? priceDisplay.actualPrice : price,
        ["all_price"]: priceDisplay.price ? priceDisplay.price : price,
        ["additional_amount"]: priceDisplay.actualPrice ? priceDisplay.actualPrice - price : 0,
        ["total_ammount"]: priceDisplay.actualPrice ? priceDisplay.actualPrice : price,
        ["addition_class"]: addOn,
        ["slot_time"]: addOn,
        ["someCheck_id"]: addOn
      };
    } else {
      appointmentData = {
        ...value,
        ["service_name"]: hostObj?.name,
        ["amount"]: priceDisplay.actualPrice ? priceDisplay.actualPrice : price,
        ["all_price"]: price,
        ["additional_amount"]: 0,
        ["total_ammount"]: priceDisplay.price ? priceDisplay.price : price,
        ["addition_class"]: addOn,
        ["slot_time"]: addOn,
        ["someCheck_id"]: addOn
      };
    }

    setValue(appointmentData);
    
    // Save to localStorage for guest booking
    saveGuestBookingData({
      appointmentData: appointmentData,
      price: priceDisplay.actualPrice || price,
      selectedDate: selectedSlot?.time,
      selectedTime: disPlayTime(selectedSlot?.time)
    });

    handleNext();
  };

  const convertDateToUtc = (data: any) => {
    if (!data) return 'Invalid date';
    try {
      const Cdate = new Date(data);
      if (isNaN(Cdate.getTime())) return 'Invalid date';
      let converted_date = Cdate.toLocaleString('en-US', {
        timeZone: 'America/New_York',
      });
      return moment(converted_date).format("dddd DD MMM YYYY");
    } catch (error) {
      console.error('Error formatting date:', error, data);
      return 'Invalid date';
    }
  };

  const handlePrice = async (e: any, data: any, errorCls: any, index: any) => {
    let isChecked = e.target.checked;
    let values = data;
    let disPrice;
    let discount;
    
    if (!selectSlots[index]) {
      setErrorAdd({
        ...errorAdd,
        [index]: {
          ["app"]: "Please select time"
        }
      });
      e.target.checked = false;
      return;
    }

    setSelectSlots({
      ...selectSlots,
      [index]: {
        ...selectSlots[index],
        isChecked
      }
    });

    if (isChecked) {
      priceArry[index] = {
        id: e.target.value,
      };
      await setPriceArry({
        ...priceArry
      });

      if (Object.keys(priceArry).length === 1) {
        discount = (Number(price) + Number(values.price)) * 10 / 100;
        disPrice = Number(price) + Number(values.price) - discount;
        setPriceDisplay(
          {
            ...priceDisplay,
            ["price"]: Number(price) + Number(values.price),
            ["actualPrice"]: disPrice
          }
        );
      }
      if (Object.keys(priceArry).length === 2) {
        discount = (Number(priceDisplay.price) + Number(values?.price)) * 15 / 100;
        disPrice = Number(priceDisplay.price) + Number(values?.price) - discount;
        setPriceDisplay({
          ...priceDisplay,
          ["price"]: Number(priceDisplay.price ? priceDisplay.price : 0) + Number(values.price),
          ["actualPrice"]: disPrice
        });
      }
      if (Object.keys(priceArry).length === 3) {
        discount = (Number(priceDisplay.price) + Number(values?.price)) * 20 / 100;
        disPrice = Number(priceDisplay.price) + Number(values?.price) - discount;
        setPriceDisplay({
          ...priceDisplay,
          ["price"]: Number(priceDisplay.price ? priceDisplay.price : 0) + Number(values.price),
          ["actualPrice"]: disPrice
        });
      }
      addOn[index] = {
        name: selectClasses[index]?.name
      };

      await setAddOn({
        ...addOn
      });
    } else {
      if (Object.keys(priceArry).length === 1) {
        setPriceDisplay({
          ...priceDisplay,
          ["price"]: Number(values.price),
          ["actualPrice"]: Number(values.price)
        });
      }
      if (Object.keys(priceArry).length === 2) {
        discount = (Number(priceDisplay.price) - Number(values?.price)) * 10 / 100;
        disPrice = Number(priceDisplay.price) - Number(values?.price) - discount;

        setPriceDisplay({
          ...priceDisplay,
          ["price"]: Number(priceDisplay.price) - Number(values.price),
          ["actualPrice"]: disPrice
        });
      }
      if (Object.keys(priceArry).length === 3) {
        discount = (Number(priceDisplay.price) - Number(values?.price)) * 15 / 100;
        disPrice = Number(priceDisplay.price) - Number(values?.price) - discount;
        setPriceDisplay({
          ...priceDisplay,
          ["price"]: Number(priceDisplay.price ? priceDisplay.price : 0) - Number(values.price),
          ["actualPrice"]: disPrice
        });
      }
      delete priceArry[index];
      setPriceArry({
        ...priceArry
      });

      delete selectSlots[index];
      setSelectSlots({ ...selectSlots });

      delete selectClasses[index];
      setSelectClasses({ ...selectClasses });
      delete addOn[index];
      setAddOn({ ...addOn });
    }
  };

  const selectTime = (e: any, i: number, value: any) => {
    setErrorAdd({
      ...errorAdd,
      [i]: {
        ["app"]: ""
      }
    });
    let allData = value.multipleSlots.find((res: any) => res.time === e.target.value);

    setSelectSlots({
      ...selectSlots,
      [i]: {
        ["appointment_date_time"]: allData?.time,
        ["appointment_type_id"]: value?.appointmentTypeID,
        ["calendar_id"]: allData?.calendarID,
        ["name"]: allData?.name,
        isChecked: !!selectSlots[i]
      }
    });
  };

  return (
    <div>
      <section className='step-container step1'>
        {!loadingWash && <div className='consult-section-heading text-center'>
          <h3>{allData?.service_name}</h3>
          <h5 className='my-4'>Choose an Appointment</h5>
          <p className='my-4'>Please choose a class time from the <span className="strong">scheduler</span> below that works best for your schedule.</p>
        </div>}

        {
          loadingWash ? <div className='loader-wash'><CircularProgress /></div> :
            (
              <>
            {host && host.length > 0 ? host.map((res: any) => (
              <div key={res.id} className="consult-card-container">
                <div className='d-flex py-3 px-3 justify-content-between '>
                  <div className='consult-info d-flex flex-column w-100'>
                    <div className='time-projection-details d-flex'>
                      <div className='time-projection'>{timeDiff(res?.time)}</div>
                      <div className='availablity'>{res?.slotsAvailable || 0}/{res?.slots || 0} left</div>
                    </div>
                    <div className='consult-date-time d-flex justify-content-between mt-3 mb-1'>
                      <div className='consult-date'>{convertDateToUtc(res?.time)} </div>
                      <div className='consult-price'>
                        <span className='price'>${res?.price || 0}</span>
                      </div>
                    </div>

                    <div className='consult-tm-dtls mb-3'>
                      <span className='consult-time'><span className='strong'> {disPlayTime(res?.time)} EST</span>  </span>
                      <span className='host-name'>| by {res?.calendar || 'Unknown'}</span>
                    </div>
                    <div className='btn-container'>
                      <button className='btn primary-blue-small-btn-40' key={res?.id} onClick={() => openAddonClass(res)}>Book</button>
                    </div>
                  </div>
                </div>

                    {/* Bundle Selection Section - Inline */}
                    {showBundles && selectedSlot && selectedSlot.id === res.id && (
                      <div className='additional-class pb-3 px-3'>
                        <hr />
                        <h2 className='text-start pb-0 mb-2 add-head' >Bundle and Save</h2>
                        <p className='additional-class-discount'>( 10% off on 1 additional class, 15% off on 2 additional classes AND 20% of on all additional classes ) </p>
                        <hr />

                        {
                          data?.map((val: any, i: any) => {
                            return (
                              <div key={i} className={`d-flex align-items-center pt-2 pb-md-3 ${data.length -1 === i ? '' : 'border-bottom'}`}>
                                <div className='ms-auto me-0'>
                                  <input
                                    type='checkbox'
                                    className='form-check-input align-self-md-end mb-3'
                                    name='price'
                                    value={val.appointmentTypeID}
                                    onChange={(e) => handlePrice(e, val, error[i], i)}
                                    checked={selectSlots[i]?.isChecked}
                                  />
                                </div>
                                <div className='class-list w-100 d-flex flex-column flex-md-row mb-3 mb-md-0 align-items-end'>
                                  <div className='class-list-inner w-100 d-flex flex-column flex-md-row align-items-center'>
                                    <div className="class-container">
                                      <label>Select Class {i + 1}</label>
                                      <p>{val?.name}</p>
                                      <h4 className="error-msgtext">{errorAdd[i]?.class}</h4>
                                    </div>

                                    <div className="appointment-container">
                                      <label>Select Appointment</label>
                                      <Form.Select aria-label="Default select example" onChange={(e) => selectTime(e, i, val)} >
                                        <option>Select Appoinment</option>
                                        {val?.multipleSlots.map((clVal: any) => (
                                          <option
                                            key={clVal.time}
                                            selected={selectSlots[i]?.appointment_date_time === clVal?.time}
                                            value={clVal.time}>{convertDateToUtc(clVal.time) ? `${convertDateToUtc(clVal.time)}, ${disPlayTime(clVal.time)}` : disPlayTime(clVal.time)}</option>
                                        ))}
                                      </Form.Select>
                                      <h4 className="error-msgtext">{errorAdd[i]?.app}</h4>
                                    </div>

                                    <div className='price-container d-flex flex-row flex-grow-1 justify-content-end justify-content-md-center'>
                                      <div className='additional-cost'><span className=''></span><span className='strong actual-price'>+${val?.price}</span></div>
                                    </div>
                                  </div>
                                  <h4 className="error-msgtext">{error?.errorIndex}</h4>
                                </div>
                              </div>
                            );
                          })
                        }

                        <hr />
                        <div className='total-amt d-flex justify-content-between'>
                          <div className='total-amount'>Total <span className='text-decoration-line-through me-1 total-actual-value'>{priceDisplay.price > priceDisplay.actualPrice && priceDisplay?.price}</span><span className='total-discounted'>${priceDisplay.actualPrice ? priceDisplay.actualPrice : price}</span></div>
                          <div><button className='primary-blue-small-btn-40 btn' onClick={() => handleBundleSelection()}>Continue</button></div>
                        </div>
                      </div>
                    )}
                  </div>
                )) : (
                  <div className="text-center p-5">
                    <h4>No appointments available</h4>
                    <p>Please check back later for available time slots.</p>
                  </div>
                )}
              </>
            )
        }
      </section>
    </div>
  );
};

export default GuestChooseDate;
